import React from 'react';
import "../services_page/services_page.css";
import "../events_page/events_page.css";
import infoIcon from "../../parm_assets/tree_icons.png";


const eventData = [
 {
    id: 1,
    text: "The Arborist Certification Programme (ACP24) is fast approaching, and we couldn't be more excited!",
    title: "Arborist Certification Programme",
    subtitle: "RHR Hotel, Kajang",
    logo: "https://ik.imagekit.io/axiomhives/parm_assets/intackl_2.png?updatedAt=1769929451984",
    bgImage: "https://ik.imagekit.io/axiomhives/parm_assets/aptcc/acp_fb_ads.jpeg?updatedAt=1769929477956" // Example: Forest/Trees
  },
  {
    id: 2,
    text: "The Malaysian Society of Arborist (PArM) is organizing an International Tropical Arboriculture Conference (INTAC 2026) in September, 2026",
    title: "INTAC 2026 Seberang Perai, Penang",
    subtitle: "The Light Hotel, Penang",
    logo: "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/hotel.webp?updatedAt=1769929449417",
    bgImage: "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC%202026%20poster-for%20puteri-2.png?updatedAt=1770217712583" // Example: Tropical green
  },
  {
    id: 3,
    text: "These events are designed to enhance understanding of soil properties, promote best practices in soil management, and underscore the significance of healthy soils in sustaining robust tree populations.",
    title: "Exploring Soil: The Foundation of Life",
    subtitle: "Workshop",
    logo: "https://ik.imagekit.io/axiomhives/parm_assets/Logo_-_PARM__pokok_bulat_.jpg-removebg-preview.png?updatedAt=1769943590225",
    bgImage: "https://ik.imagekit.io/axiomhives/parm_assets/about_us/WhatsApp%20Image%202026-02-05%20at%209.48.07%20AM.jpeg?updatedAt=1770304012940" // Example: Tropical green
  },
  {
    id: 4,
    text: "The Malaysia Tree Climbing Championship 2025 (MTCC 2025) is fast approaching, and we couldn't be more excited!",
    title: "Malaysia Tree Climbing Championship",
    subtitle: "Taman Putra Perdana, Putrajaya",
    logo: "https://ik.imagekit.io/axiomhives/parm_assets/Logo_-_PARM__pokok_bulat_.jpg-removebg-preview.png?updatedAt=1769943590225",
    bgImage: "https://ik.imagekit.io/axiomhives/parm_assets/tree_climb.jpeg?updatedAt=1769929451010" // Example: Tropical green
  },
  // {
  //   id: 5,
  //   text: "The Arborist Certification Program is a professional accreditation that validates an individual's knowledge and skills in tree care and management",
  //   title: "Arborist Certification Program",
  //   subtitle: "ACP Class, RHR Kajang, Selangor",
  //   logo: "https://cdn.britannica.com/18/187118-050-848A8F58/leaves-ginkgo-tree.jpg?w=400&h=225&c=crop",
  //   theme: "light"
  // },
  // {
  //   id: 6,
  //   text: "These events are designed to enhance understanding of soil properties, promote best practices in soil management, and underscore the significance of healthy soils in sustaining robust tree populations.",
  //   title: "Exploring Soil: The Foundation of Life",
  //   subtitle: "Workshop",
  //   logo: "https://cdn.britannica.com/18/187118-050-848A8F58/leaves-ginkgo-tree.jpg?w=400&h=225&c=crop",
  //   theme: "green"
  // }
];

const EventParm = () => {
  return (
    <div className="page-container">
      <section className="about-hero-section">
        <div className="about-hero-content">
          <h1 className="about-page-title">Events</h1>
          <nav className="breadcrumb">
            <span className="breadcrumb-item">Home</span>
            <span className="breadcrumb-separator"> &gt; </span>
            <span className="breadcrumb-item active">Events</span>
          </nav>
        </div>
      </section>

      <section className="event-page-section">
        <div className="event-page-grid">
          {eventData.map((event) => (
            <div 
              key={event.id} 
              className="event-page-card"
              style={{ 
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url(${event.bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white' // Ensures text is readable over images
              }}
            >
              <div className="quote-event-page-icon">"</div>
              <p className="event-page-text">{event.text}</p>
              
              <div className="event-page-footer">
                <img src={event.logo} alt={event.title} className="event-page-logo" />
                <div className="event-page-info">
                  <h4 className="event-page-title">{event.title}</h4>
                  <p className="event-page-subtitle">{event.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default EventParm;